module.exports = __webpack_public_path__ + "static/media/soundtrap-logo.f3c20b80.svg";